import {createActions} from 'client/framework';

export default createActions(null, ['SET_QUESTION_SET_ID']);
